import {useEffect} from 'react'
/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {KTableHeader, KTableSelectionCellLav} from '../../../../../../components/UI'
import {useMemo} from 'react'
import {LaundryModel} from '../../../../model'
import useEnterpriseService from '../../../../../central/hooks/useEnterpriseService'
const ColumnTable = () => {
  const {selectedLav, data} = useKTable()
  const {enterPriseByOrders, getEnterpriseByOrderList} = useEnterpriseService()

  useEffect(() => {
    getEnterpriseByOrderList()
  }, [])

  const columns: Column<LaundryModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelectLav={true} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCellLav id={props.data[props.row.index].id} />,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Subcontratista'
            name='empresa'
            selecteable
            data={enterPriseByOrders}
          />
        ),
        accessor: 'empresa',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de documento'
            name='numeroDocumento'
            searcheable
          />
        ),
        accessor: 'numeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nombre Completo'
            name='nombreResponsable'
            searcheable
          />
        ),
        accessor: 'nombreResponsable',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de orden de lavado'
            name='nroOrden'
            searcheable
            number
          />
        ),
        accessor: 'nroOrden',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de boleta'
            name='nroBoleta'
            searcheable
            number
          />
        ),
        accessor: 'nroBoleta',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad prendas'
            name='cantidadPrendas'
            searcheable
            number
          />
        ),
        accessor: 'cantidadPrendas',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad KG'
            name='cantidadKG'
            searcheable
            number
          />
        ),
        accessor: 'cantidadKG',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Bolsa'
            name='bolsaCorrelativo'
            searcheable
            number
          />
        ),
        accessor: 'bolsaCorrelativo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Rotulado'
            name='rotuladoCorrelativo'
            searcheable
            number
          />
        ),
        accessor: 'rotuladoCorrelativo',
      },
    ],
    [selectedLav, data, enterPriseByOrders],
  )

  return {columns}
}

export {ColumnTable}
